var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.125 0C6.8465 0 0.125 6.7215 0.125 15C0.125 23.2785 6.8465 30 15.125 30C23.4035 30 30.125 23.2785 30.125 15C30.125 6.7215 23.4035 0 15.125 0ZM15.125 3C21.7475 3 27.125 8.376 27.125 15C27.125 21.6225 21.7475 27 15.125 27C8.501 27 3.125 21.6225 3.125 15C3.125 8.376 8.501 3 15.125 3ZM13.0025 15L8.76049 10.7565C8.17549 10.1715 8.17549 9.22048 8.76049 8.63548C9.34549 8.05048 10.2965 8.05048 10.8815 8.63548L15.125 12.879L19.367 8.63548C19.952 8.05048 20.903 8.05048 21.488 8.63548C22.0745 9.22048 22.0745 10.1715 21.488 10.7565L17.246 15L21.488 19.242C22.0745 19.827 22.0745 20.778 21.488 21.363C20.903 21.9495 19.952 21.9495 19.367 21.363L15.125 17.121L10.8815 21.363C10.2965 21.9495 9.34549 21.9495 8.76049 21.363C8.17549 20.778 8.17549 19.827 8.76049 19.242L13.0025 15Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.5d8dcf91a466d26f93544259397a0db9.svg";
export { ForwardRef as ReactComponent };